import { Dialog } from "@headlessui/react"
import { FC, useEffect } from "react"
import { X } from "heroicons-react"
import UserContract from "../../../account/user-contract/UserContract"

type AdminUserContractModalProps = {
  open: boolean
  onClose: () => void
  userId: number | undefined
  isModal: boolean
}
const AdminUserContractModal: FC<AdminUserContractModalProps> = (props) => {
  const { onClose, open, userId } = props

  const renderMain = () => {
    return (
      <div
        className="bg-white elev-b-sm rounded-lg overflow-hidden"
        style={{
          overflowY: "auto",
          height: props.isModal ? "80vh" : "35.5vh",
          width: props.isModal ? "100vh" : "80vh",
          padding: props.isModal ? 42 : 20
        }}
      >
        <UserContract userId={userId} viewOnly={false} onSubmitClose={() => onClose()} hideTitle={!props.isModal} />
      </div>
    )
  }

  return props.isModal ? (
    <Dialog open={open} onClose={onClose} className="relative">
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div>
          <div className={`flex justify-end`}>
            <X className="h-4 cursor-pointer mt-1" style={{ position: "absolute" }} onClick={onClose} />
          </div>
          {renderMain()}
        </div>
      </div>
    </Dialog>
  ) : (
    renderMain()
  )
}

export default AdminUserContractModal
